import { render } from "./VehicleBrandStep.vue?vue&type=template&id=28cdfab7&scoped=true"
import script from "./VehicleBrandStep.vue?vue&type=script&lang=js"
export * from "./VehicleBrandStep.vue?vue&type=script&lang=js"

import "./VehicleBrandStep.vue?vue&type=style&index=0&id=28cdfab7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cdfab7"]])

export default __exports__